import { useEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import Main from "components/MainDetails/Main";
import { useToken } from "states/auth/hooks";
import { useLoadItems } from "states/article/hooks";
import { currentIdState, listState } from "states/article";
import { del } from "api/article";
import { getCategoryName } from "./common";

interface Props {
  stateName: string;
}

const List = ({ stateName }: Props) => {
  const [currentId, setCurrentId] = useRecoilState(currentIdState(stateName));
  const list = useRecoilValue(listState(stateName));
  const token = useToken();
  const loadItems = useLoadItems(stateName);

  const getTitle = (article?: Article) =>
    article
      ? `# ${getCategoryName(article.category)} / ${article.name}`
      : "未命名";

  useEffect(() => {
    loadItems();
  }, [loadItems]);

  return (
    <Main
      title="活动资讯"
      itemIds={list.map(({ _id }) => _id)}
      renderItem={(id) => (
        <span>{getTitle(list.find(({ _id }) => id === _id))}</span>
      )}
      onSelect={setCurrentId}
      onCreate={() => setCurrentId("")}
      onRemove={async (id) => {
        if (window.confirm("确认删除？")) {
          await del({ id, token });
          await loadItems();
          if (id === currentId) setCurrentId("");
        }
      }}
      currentId={currentId}
    />
  );
};

export default List;
